// Frontend JavaScript for WebAsk Integration
document.addEventListener('DOMContentLoaded', function() {
    initWebAskSurveys();
});

function initWebAskSurveys() {
    const surveyContainers = document.querySelectorAll('.webask-survey-container');
    
    surveyContainers.forEach(container => {
        const surveyId = container.getAttribute('data-survey-id');
        if (surveyId && container.innerHTML.trim() === '') {
            loadSurveyEmbed(container, surveyId);
        }
    });
}

function loadSurveyEmbed(container, surveyId) {
    // Show loading state
    container.innerHTML = '<div class="webask-loading">Загрузка опроса...</div>';
    
    // Get survey data via AJAX
    fetch(webask_ajax.ajax_url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
            action: 'webask_get_survey_data',
            survey_id: surveyId,
            nonce: webask_ajax.nonce
        })
    })
    .then(response => response.json())
    .then(data => {
        if (data.success && data.data.url_shared) {
            // Create iframe for embed style surveys
            const iframe = document.createElement('iframe');
            iframe.src = data.data.url_shared;
            iframe.style.width = '100%';
            iframe.style.height = container.style.minHeight || '600px';
            iframe.style.border = 'none';
            iframe.frameBorder = '0';
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('webkitallowfullscreen', '');
            iframe.setAttribute('mozallowfullscreen', '');
            
            // Replace loading content with iframe
            container.innerHTML = '';
            container.appendChild(iframe);
            
            // Auto-resize iframe based on content (if same origin)
            iframe.addEventListener('load', function() {
                try {
                    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                    if (iframeDoc) {
                        const resizeIframe = () => {
                            const height = iframeDoc.documentElement.scrollHeight;
                            if (height > 100) { // Minimum height check
                                iframe.style.height = height + 'px';
                            }
                        };
                        
                        // Initial resize
                        resizeIframe();
                        
                        // Listen for content changes
                        const observer = new MutationObserver(resizeIframe);
                        observer.observe(iframeDoc.body, {
                            childList: true,
                            subtree: true,
                            attributes: true
                        });
                    }
                } catch (e) {
                    // Cross-origin restrictions prevent auto-resize
                    console.log('Auto-resize not available for cross-origin iframe');
                }
            });
            
        } else {
            container.innerHTML = '<div class="webask-error">Ошибка загрузки опроса</div>';
        }
    })
    .catch(error => {
        console.error('Error loading survey:', error);
        container.innerHTML = '<div class="webask-error">Ошибка загрузки опроса</div>';
    });
}

// Responsive iframe helper
function makeIframesResponsive() {
    const iframes = document.querySelectorAll('iframe[src*="webask.io"]');
    iframes.forEach(iframe => {
        if (!iframe.classList.contains('webask-responsive')) {
            iframe.classList.add('webask-responsive');
            
            // Wrap iframe in responsive container if not already wrapped
            if (!iframe.parentNode.classList.contains('webask-responsive-wrapper')) {
                const wrapper = document.createElement('div');
                wrapper.className = 'webask-responsive-wrapper';
                iframe.parentNode.insertBefore(wrapper, iframe);
                wrapper.appendChild(iframe);
            }
        }
    });
}

// Initialize responsive iframes on load and window resize
window.addEventListener('load', makeIframesResponsive);
window.addEventListener('resize', makeIframesResponsive);

// Post message listener for iframe communication
window.addEventListener('message', function(event) {
    // Only listen to messages from webask.io domains
    if (!event.origin.includes('webask.io')) {
        return;
    }
    
    if (event.data && event.data.type === 'webask_survey_height') {
        // Find the iframe that sent the message
        const iframes = document.querySelectorAll('iframe[src*="webask.io"]');
        iframes.forEach(iframe => {
            if (iframe.contentWindow === event.source) {
                iframe.style.height = event.data.height + 'px';
            }
        });
    }
});